<script setup>
import { computed, ref } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useAlert } from 'dashboard/composables';
import { useLocoI18n } from 'custom/composables/useLocoI18n';
import { usePins } from './usePins';

// Conversation header: pin the conversation to the top of my list
const props = defineProps({
  conversationId: { type: Number, required: true },
});

const { t } = useLocoI18n();
const { isPinned, toggle } = usePins();
const isBusy = ref(false);

const pinned = computed(() => isPinned(props.conversationId));

const onClick = async () => {
  isBusy.value = true;
  try {
    await toggle(props.conversationId);
  } catch (error) {
    useAlert(error.response?.data?.error || error.message);
  } finally {
    isBusy.value = false;
  }
};
</script>

<template>
  <Button
    v-tooltip.bottom="pinned ? t('LOCO.PINS.UNPIN') : t('LOCO.PINS.PIN')"
    :icon="pinned ? 'i-lucide-pin-off' : 'i-lucide-pin'"
    sm
    ghost
    :color="pinned ? 'blue' : 'slate'"
    :is-loading="isBusy"
    @click="onClick"
  />
</template>
